import { FormattedMessage } from '@flipster/i18n';
import { useRouter } from '@flipster/i18n/routing';
import { Modal } from '@flipster/react/design-system/modal';

import { PremiumEarnNudgeContents } from '../premium-earn-nudge-contents';

interface Props {
  onClickNext: () => void;
  closeModal: () => void;
}

const InfoStep = ({ onClickNext, closeModal }: Props) => {
  const router = useRouter();
  return (
    <>
      <Modal.Content>
        <PremiumEarnNudgeContents
          onClickDetail={() => {
            router.push('/earn/details/premium-usdt');
            closeModal();
          }}
        />
      </Modal.Content>
      <Modal.Footer>
        <Modal.Button
          label={<FormattedMessage id='Earn.r260220.Pusdt_subscribe_with_usdt_now' />}
          size='large'
          onClick={onClickNext}
        />
      </Modal.Footer>
    </>
  );
};

export default InfoStep;
